import React from 'react';
import { Link } from 'react-router-dom';

const SubscriptionCancelled: React.FC = () => {
  return (
    <div className="subscription-page" style={{ minHeight: '100vh', background: '#fff', color: '#044080' }}>
      <header style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px 24px', borderBottom: '1px solid rgba(0,0,0,0.04)' }}>
        <img className="subscription-logo" src="/HomeStream.png" alt="Homestream" style={{ height: 50, objectFit: 'cover', width: '20%' }} />
      </header>

      <main style={{ maxWidth: 1100, margin: '40px auto', padding: '0 20px' }}>
        <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
          <div style={{ textAlign: 'center', maxWidth: 720 }}>
            <h1 style={{ color: '#044080', fontSize: 32, marginBottom: 12 }}>Subscription Not Completed</h1>
            <p style={{ color: '#374151', marginBottom: 20 }}>It looks like your checkout was cancelled or not completed. No payment was taken.</p>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/subscription-plans" style={{ padding: '10px 18px', border: '2px solid #044080', color: '#044080', borderRadius: 6, textDecoration: 'none' }}>Return to Plans</Link>
              <Link to="/subscription-plans" style={{ padding: '10px 18px', background: '#fff', color: '#044080', borderRadius: 6, textDecoration: 'none', border: '2px solid #044080' }}>Try Again</Link>
            </div>
          </div>
        </div>
      </main>

      <footer style={{ marginTop: 40, background: '#f3f4f6', padding: '36px 20px' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 20, alignItems: 'start' }}>
          <div>
            <div style={{ color: '#374151', marginBottom: 12 }}>Questions? Call 000-800-919-1743 (free)</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <a href="#" style={{ color: '#044080', textDecoration: 'underline' }}>FAQ</a>
              <a href="#" style={{ color: '#044080', textDecoration: 'underline' }}>Cookie Preferences</a>
            </div>
            <div style={{ marginTop: 16 }}>
              <select style={{ padding: '8px 10px', borderRadius: 4 }} defaultValue="en">
                <option value="en">English</option>
                <option value="es">Español</option>
              </select>
            </div>
          </div>

          <div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <a href="#" style={{ color: '#044080', textDecoration: 'underline' }}>Help Centre</a>
              <a href="#" style={{ color: '#044080', textDecoration: 'underline' }}>Corporate Information</a>
            </div>
          </div>

          <div>
            <a href="#" style={{ color: '#044080', textDecoration: 'underline' }}>Terms of Use</a>
          </div>

          <div>
            <a href="#" style={{ color: '#044080', textDecoration: 'underline' }}>Privacy</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SubscriptionCancelled;
